// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SaveProjectCaeDTO')
export class SaveProjectCaeDTO {

  @JsonProperty('projectId', 'Number')
  public projectId: number = undefined;

  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('guid', 'String')
  public guid: string = undefined;

  @JsonProperty('isSaveSuccess', 'Boolean')
  public isSaveSuccess: boolean = undefined;
}
